
import { getCookie } from '@/utils/cookie-storage'
import pcPopup from '@/components/common/popup/pc-popup.vue'
import citySelect from '@/components/city-select.vue'
import locationBtn from '@/components/common/btn/location-btn.vue'
import headBanner from '@/components/common/banner/head-banner.vue'
import localSuperBuy from '@/components/local-super-buy/local-super-buy.vue'
import goldDealer from '@/components/gold-dealer/gold-dealer.vue'
import whitePage from '@/components/white-page/index.vue'
import tigerMachine from '@/components/tiger-machine/tiger-machine.vue'
import chooseCar from '@/components/choose-car.vue'
import { getCityIdPromise } from '@/mixins/getCityId'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import {
  fetchActivityInfo,
  fetchAppUserInfo,
  fetchEncryptInfo,
} from '@/http/api'
import { getXunJiaInfo3Cookie } from '@/composables/use-cookie-function'
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
} from 'vue'
import { isAHigherVersionThanB, shareConfig } from '@/utils/app-function'
import { defaultSharePic } from '@/const/hosts'
import { Toast } from 'vant'
import { isAndroid, isiOS, isPcApp } from '@/utils/runTimeEnv'
export default defineComponent({
  components: {
    citySelect,
    pcPopup,
    headBanner,
    locationBtn,
    localSuperBuy,
    goldDealer,
    whitePage,
    tigerMachine,
    chooseCar,
  },
  setup() {
    const win: any = window
    const store = useStore()
    const route = useRoute()
    const data = reactive({
      browserEnv: computed(() => store.state.browserEnv),
      appLoginCookieKey: computed(() => store.state.appLoginCookieKey),
      carSidBarVisible: false,
      citySelectVisible: false,
      carInfo: computed(() => store.state.carInfo),
      cxSelect: {} as any,
      activityInfo: computed(() => store.state.activityInfo),
      locationInfo: computed(() => store.state.locationInfo),
      carSelectVisible: false, // 选车弹窗
    })
    // 禁止页面滚动
    watch(
      () => data.citySelectVisible,
      (nVal: any) => {
        if (nVal === true) {
          document.body.style.overflow = 'hidden'
          document.body.style.position = 'fixed'
        } else {
          document.body.style.overflow = 'scroll'
          document.body.style.position = 'static'
        }
      },
    )
    watch(
      () => data.activityInfo,
      (nVal: any) => {
        document.title = nVal.title
      },
    )
    const styleObj = computed(() => {
      const backgroundImgRgb = data.activityInfo.backgroundImgRgb || ''
      const backgroundImgUrl = data.activityInfo.backgroundImgUrl || ''
      return {
        background: `${backgroundImgRgb} url(${backgroundImgUrl}) repeat center/100vw 53.33333vw`,
      }
    })
    const methods = {
      init() {
        // 配置分享信息
        shareConfig({
          title: '天天抽奖，瓜分百万现金',
          desc: '海量购车优惠等着你~',
          link: window.location.href,
          imgUrl: defaultSharePic,
          type: 'all',
        })
        // 获取活动信息
        methods.getActivityInfo()
        // 初始化城市
        methods.initCityLocation()
        // 初始化选车插件
        // methods.initCarSideBar()
        // 设置游戏登录状态
        methods.setGameStatus()
        if (data.browserEnv === 1) {
          // 初始化app用户信息
          methods.getAppUserInfo()
        }
      },
      // 设置游戏登录状态
      setGameStatus() {
        let cookiePhoneObj: any = getXunJiaInfo3Cookie()
        let phone = ''
        // 设置游戏登录状态和当前H5用户游戏信息
        if (data.browserEnv === 1) {
          if (getCookie(data.appLoginCookieKey)) {
            store.commit('setGameLoginStatus', true)
          }
        } else {
          if (
            cookiePhoneObj &&
            cookiePhoneObj.phone &&
            cookiePhoneObj.encryptPhone
          ) {
            phone = cookiePhoneObj.encryptPhone
            store.commit('setGameLoginStatus', true)
          }
        }
        store.dispatch('getGameInfo', { actId: route.query.actId, phone })
      },
      //  获取app登录用户信息 (为逻辑统一，该方法放全局下，不放在组件多次调用)
      //  1.更新游戏登录状态; 2.更新游戏信息;
      async getAppUserInfo() {
        const appUserInfoRes: any = await fetchAppUserInfo()
        if (appUserInfoRes.code === 200) {
          store.commit('setPcsuv', appUserInfoRes.data.id)
          if (appUserInfoRes.data.code === 0) {
            // 查询成功会将用户状态置为已非首次参与
            store.commit('setAppPhone', appUserInfoRes.data.phone) // 设置app原手机号
            let EtguardInfoRes: any = await fetchEncryptInfo({
              phones: window.encryStr(String(appUserInfoRes.data.phone)),
            })
            if (EtguardInfoRes.code === 1) {
              store.commit('setAppEncryptPhone', EtguardInfoRes.msg[0].encrypt) // 设置app加密原手机号
              store.commit('setGameLoginStatus', true) // 更新游戏登录状态
              store.dispatch('getGameInfo', {
                actId: route.query.actId,
                phone: EtguardInfoRes.msg[0].encrypt,
              }) // 更新游戏信息
            } else {
              Toast('加密失败')
              return
            }
          } else {
            // Toast('用户未登录')
          }
        }
      },
      // 城市定位初始化
      initCityLocation() {
        if (isPcApp()) {
          methods.initAppCityLocation()
        } else {
          methods.initWapCityLocation()
        }
      },
      // wap定位有缓存取缓存，无则定位
      initWapCityLocation() {
        if (window.LocateAuto) {
          window.LocateAuto.init({
            device: 'wap',
            callback: (locationInfo: any) => {
              console.info('c端定位= ', locationInfo)
              if (
                locationInfo?.cityId !== undefined &&
                locationInfo?.cityId !== null
              ) {
                store.commit('setLocationInfo', locationInfo)
              } else {
                // 没有定位方法，默认广州
                store.commit('setLocationInfo', {
                  city: '广州',
                  cityId: 1,
                  cityCode: '440100',
                  dataType: 'default',
                  msg: '未引入LocateAuto方法',
                  locationVersion: '',
                })
              }
            },
          })
        } else {
          // 没有定位方法，默认广州
          store.commit('setLocationInfo', {
            city: '广州',
            cityId: 1,
            cityCode: '440100',
            dataType: 'default',
            msg: '未引入LocateAuto方法',
            locationVersion: '',
          })
        }
      },
      /**  APP端初始化城市定位 **/
      initAppCityLocation() {
        getCityIdPromise()
          .then((res: any) => {
            if (!res) {
              return
            }
            if (res.city.indexOf('市') !== -1) {
              res.city = res.city.slice(0, -1)
            }
            store.commit('setLocationInfo', res)
          })
          .catch(() => console.warn('定位失败'))
      },
      // b端城市侧边栏
      initCitySideBar() {
        new win.xchoose({
          id: 'location',
          dw: '2',
          location: true,
          // 初始定位
          locationBack: (bLocationInfo: any) => {
            methods.isUseBCityStorage(bLocationInfo, true)
          },
          // 侧边弹窗
          area: {
            show: true,
            cookie: true,
            callback: (bLocationInfo: any) => {
              let locationInfo: any = {
                cityId: bLocationInfo.cityId,
                city: bLocationInfo.city,
              }
              store.commit('setLocationInfo', locationInfo)
            },
          },
        })
      },
      // 是否启用B端的定位缓存
      isUseBCityStorage(bLocationInfo: any, isB: boolean) {
        // B端定位 => 有cookie缓存则，取B端 无cookie缓存则，取C端
        if (isB && getCookie('ztLocate')) {
          let locationInfo: any = {
            cityId: bLocationInfo.cityId,
            city: bLocationInfo.city,
          }
          store.commit('setLocationInfo', locationInfo)
        } else {
          methods.initCityLocation()
        }
      },
      // 切换城市选择侧边栏
      toggleSelectCitySideBar(value: boolean) {
        // app >= 5.40.3 版本
        if (
          isPcApp() &&
          (isAndroid() ||
            (isiOS() &&
              isAHigherVersionThanB(
                (route.query.app_ver as string) || '',
                '5.40.2',
              )))
        ) {
          window.location.href = 'pcautobrowser://city-list/'
          window.setCityId = (value: string) => {
            const cityData =
              typeof value === 'string' ? JSON.parse(value) : value
            const locationMap: any = {
              gps: 'geolocation',
              ip: 'ipJson',
              user: 'user',
            }
            store.commit('setLocationInfo', {
              cityId: cityData?.id || 1,
              city: cityData?.name || '广州',
              cityCode: cityData?.cityCode || '',
              locationMessage: '',
              dataType: locationMap[cityData.locationType] || 'default',
              msg: '',
            })
          }
          // 安卓 app 竟然有两个回调，忽略 locationChange 回调
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          window.locationChange = () => {}
        } else {
          data.citySelectVisible = value
        }
      },
      // 设置城市cookie
      setCityCookie(cityId: number | string) {
        // 用户偏好设置
        if (!window.LocateAuto) return
        window.LocateAuto.setByCityId(
          cityId,
          (data: any) => {
            // 成功请求接口后执行方法
            const cookie = {
              // 兼容旧版城市定位cookie(locationWap)
              pro: data.pro, // 定位的省份
              proCode: data.proCode, // 定位的省份ID
              city: data.city, // 定位的城市
              cityCode: data.cityCode, // 定位的城市ID
              regionPro: data.proId, // 经销商省份ID
              regionCity: data.cityId, // 经销商城市ID
              url: data.url, // 对应分站页面地址
              expires: data.expires, // 过期时间
            }
            window.Locate.setCookie(
              'locationWap',
              window.Locate.stringifyResult(cookie),
            )
            const AplocationWapCookie = {
              // 车型库的城市定位公用cookie(AplocationWap)
              regionId: data.cityId,
              regionName: data.city,
            }
            window.Locate.setCookie(
              'AplocationWap',
              window.Locate.stringifyResult(AplocationWapCookie),
            )
          },
          (error: Error) => {
            // 请求接口异常执行方法，返回的数据记录了错误信息
            // eslint-disable-next-line no-console
            console.log(error)
          },
        )
      },
      // 选择城市
      selectCity: (cityItem: any) => {
        store.commit('setLocationInfo', cityItem)
        data.citySelectVisible = false
      },
      // 控制城市侧边栏
      togglePCPopupVisible(visible: boolean, popupType: string) {
        if (popupType === 'citySideBar') {
          data.citySelectVisible = visible
        }
      },
      // 获取活动信息
      async getActivityInfo() {
        if (!route.query.actId) return
        const res = await fetchActivityInfo({ actId: route.query.actId })
        if (res.data !== null) {
          store.commit('setActivityInfo', res.data)
        }
      },
      // 显示车品牌侧边栏
      openCarSideBar() {
        data.carSelectVisible = true
      },
      // 选中车品牌
      toChooseCar(res: any) {
        store.commit('setCarInfo', res)
        methods.toHideSelectCar()
      },
      // 关闭车品牌侧边栏
      toHideSelectCar() {
        data.carSelectVisible = false
      },
    }

    onMounted(() => {
      methods.init()
    })

    return {
      ...toRefs(data),
      ...methods,
      route,
      styleObj,
    }
  },
})
